module.exports = __webpack_public_path__ + "img/avatar2_g.52ccda5b.svg";